<template>
  <a-config-provider
    :locale="zhCN"
    :size="globalSize"
    :theme="{
      token: {
        colorPrimary: '#fccf00', // 全局主色

      },
      // 单独定制某类组件的样式
      components: {
        Button: {
          // colorPrimary: '#00885a', // 按钮主色单独覆盖
        },
        Input: {
          // borderRadius: 2, // 输入框圆角单独覆盖
        },
      },
    }"
  >
    <router-view />
  </a-config-provider>
</template>
<script setup lang="ts">
import { ref } from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
const globalSize = ref("middle");
</script>
<style src="wow.js/css/libs/animate.css"></style>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
